import CutOffText from '@/components/CutOffText';
import Rating from '@/components/Rating';
import { IS_USE_CENTIMETERS_SIZE_COUNTRY } from '@/constants/is-use-centimeters-size-country';
import { sizeList } from '@/constants/sizeList';
import useIsMobile from '@/hooks/use-is-mobile';
import htmlStringImgUrlConverter from '@/util/htmlStringImgUrlConverter';
import Image from 'next/image';
import classes from './reviewsPage.module.css';

const ReviewItem = props => {
  const { item, onItemClick, onItemImageClick } = props;

  const { size, fitness, body_type } = item;

  const toHTML = str => ({
    __html: htmlStringImgUrlConverter(str),
  });

  const isMobile = useIsMobile();

  const cutOffLength = isMobile ? 200 : 6205;

  let sizeEle = null;
  let sizeTitle = '';

  if (size && size !== '0-0-0' && size.indexOf('-') > -1) {
    const sizeArray = size.split('-');

    sizeTitle = 'Custom Size';
    sizeEle = (
      <>
        <li>
          Bust: {sizeArray[0]}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
        <li>
          Waist: {sizeArray[1]}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
        <li>
          Hips: {sizeArray[2]}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
      </>
    );
  } else if (size && size !== '0-0-0') {
    const findSize = sizeList.find(temp => temp.size.toString() === size);

    sizeTitle = ` ${size}`;
    sizeEle = findSize ? (
      <>
        <li>
          Bust: {findSize.bust}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
        <li>
          Waist: {findSize.waist}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
        <li>
          Hips: {findSize.hip}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? 'cm' : 'inch'}
        </li>
      </>
    ) : (
      <li>&nbsp;{size}</li>
    );
  }

  const maybeSize =
    size && size !== '0-0-0' ? (
      <>
        <li>SIZE ORDERED : {sizeTitle}</li>
        {sizeEle}
      </>
    ) : null;

  return isMobile ? (
    <li className={classes.listitem}>
      <div className='flex'>
        <div className={classes.leftproductinfo}>
          <Image
            onClick={() => {
              onItemClick(item);
            }}
            src={item.product.small_image.url}
            className={classes.proimg}
            alt={item.product.name}
            width={130}
            height={190}
          />

          <p
            onClick={() => {
              onItemClick(item);
            }}
            className={classes.name}
            dangerouslySetInnerHTML={toHTML(item.product.name)}
          />
        </div>
        <div className={classes.rightproductinfo}>
          <ul>
            <li className={classes.nikename}>BY {item.nickname}</li>
            <p className={classes.date}>{item.created_at}</p>
            <li>
              <Rating
                rating={item.average_rating}
                disabled
              />
            </li>
            <li className={classes.rate} />
            {fitness ? <li className={classes.fitness}>Fitness:&nbsp;{fitness}</li> : null}
            {body_type ? <li className={classes.bodytype}>BodyType:&nbsp;{body_type}</li> : null}
            {maybeSize}
          </ul>
        </div>
      </div>
      <div className={classes.reviewinfo}>
        <p className={classes.reviewtitle}>{item.summary}</p>

        <p className={classes.reviewcontent}>
          <CutOffText
            text={item.text}
            length={cutOffLength}
          />
        </p>
        <div className='flex gap-2.5 overflow-auto'>
          {item.review_image?.map((ri, rix) => (
            <div
              key={rix}
              className='relative h-[150px] w-[120px] flex-none'
            >
              <Image
                className=' object-cover'
                src={ri.url}
                onClick={() => {
                  onItemImageClick(item.review_image, rix);
                }}
                fill
                sizes='640px'
                alt='Customer Review Photo'
              />
            </div>
          ))}
        </div>
      </div>
    </li>
  ) : (
    <li className={classes.listitem}>
      <div className={classes.productinfo}>
        <div className={classes.leftproductinfo}>
          <Image
            onClick={() => {
              onItemClick(item);
            }}
            src={item.product.small_image.url}
            className={classes.proimg}
            alt={item.product.name}
            width={130}
            height={190}
          />
          <p
            onClick={() => {
              onItemClick(item);
            }}
            className={classes.name}
            dangerouslySetInnerHTML={toHTML(item.product.name)}
          />
        </div>
        <div className={classes.rightproductinfo}>
          <ul>
            <li className={classes.nikename}>BY {item.nickname}</li>
            <li>
              <Rating
                rating={item.average_rating}
                disabled
              />
            </li>
            <li className={classes.rate} />
            {fitness ? <li className={classes.fitness}>Fitness:&nbsp;{fitness}</li> : null}
            {body_type ? <li className={classes.bodytype}>BodyType:&nbsp;{body_type}</li> : null}
            {maybeSize}
          </ul>
        </div>
      </div>
      <div className={classes.reviewinfo}>
        <p className={classes.reviewtitle}>{item.summary}</p>
        <p className={classes.date}>{item.created_at}</p>
        <p className={classes.reviewcontent}>
          <CutOffText
            text={item.text}
            length={cutOffLength}
          />
        </p>
        <div className='flex gap-2.5 overflow-auto'>
          {item.review_image?.map((ri, rix) => (
            <div
              className='relative h-[150px] w-[120px] flex-none'
              key={rix}
            >
              <Image
                className='object-cover'
                src={ri.url}
                onClick={() => {
                  onItemImageClick(item.review_image, rix);
                }}
                fill
                alt='Customer Review Photo'
                sizes='640px'
              />
            </div>
          ))}
        </div>
      </div>
    </li>
  );
};

export default ReviewItem;
